// correspond à la fin de l'article 7 dans les contrats

export function renderRemuneration(pdf) {
  pdf.text(
    "une rémunération forfaitaire de 900 euros correspondant environ à 72 % des honoraires perçus pour une journée moyenne. Conformément aux dispositions de l'article R.4127-66 du code de la santé publique (code de déontologie médicale), le remplacement terminé, le remplaçant doit cesser toute activité s'y rapportant et transmettre les informations nécessaires à la continuité des soins."
  );
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/Remuneration.js